module.exports = require("./luy.d.ts");